import React, { useState } from "react";
import { useEffect } from "react";
import InputRow from "./InputRow";

function EditItem({ labels, item, isEdit: isVisible, onSubmit: handleSubmit }) {
  useEffect(() => {}, []);
  return (
    <div
      style={{
        transform: isVisible ? "rotateX(0deg)" : "rotateX(90deg)",
      }}
      className="edit-con"
    >
      <h3>Edit Item</h3>
      <form onSubmit={handleSubmit}>
        {labels.map((label, index) => {
          return (
            label !== "exp" &&
            label !== "__v" &&
            label !== "manufacture_date" &&
            label !== "_id" &&
            label !== "merchant_id" &&
            label !== "images" &&
            label !== "expiry_date" &&
            label !== "merchant_name" &&
            label !== "createdAt" &&
            label !== "updatedAt" &&
            label && (
              <InputRow
                key={index + label}
                name={label}
                label={label}
                defaultValue={item[label]}
                type={typeof item[label] === "number" ? "number" : "text"}
              />
            )
          );
        })}
        <button>Apply Changes</button>
      </form>
    </div>
  );
}

export default EditItem;
